<template>
  <Grid
    :pageable="false"
    :resizable="true"
    :reorderable="true"
    :sortable="false"
    :row-height="25"
    :data-items="vendorPartsList"
    :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
    @columnresize="handleColumnResize"
    @columnreorder="handleColumnReorder"
    class="grid"
  >
    <template v-slot:commandsHeader="{props, listeners}">
      <div class="d-flex justify-content-center align-items-center">
        <grid-settings :gridId="gridId" :fields="fields" />
      </div>
    </template>

    <template v-slot:commands="{props}">
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <!-- <b-button size="sm" class="btn btn-primary" variant="primary" @click="onEdit(props.dataItem)">
            <i class="fa fa-edit"></i>
          </b-button> -->
          <i @click="onEdit(props.dataItem)" class="table-action-icon-edit fa fa-edit mr-2"></i>

          <i @click="onDelete(props.dataItem)" class="table-action-icon-delete fa fa-trash"></i>

          <!-- <b-button size="sm" variant="danger" @click="onDelete(props.dataItem)">
            <i class="fa fa-trash"></i>
          </b-button> -->
        </div>
      </td>
    </template>
  </Grid>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import fields from './fields';

import GridSettings from '@/shared/components/GridSettings';

export default {
  components: {
    GridSettings,
  },
  data: () => ({
    prepareColumnsData,
    address: {},
    currentTypeId: 1,
    fields: fields,
    buttonsHeaderVisible: true,
    gridId: GRID_ID.OFFER_VENDOR_PARTS,
    activeEditId: 0,
    companyId: 0,
  }),
  computed: {
    ...mapGetters('offers', [
      'vendorPartsList',
      'offerById',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.OFFER_VENDOR_PARTS);
    },
  },
  methods: {
    ...mapActions('offers', [
      'deleteOffer',
      'deleteVendorPartFromList',
      'getOffersForCompanyId',
    ]),
    ...mapMutations('offers', [
      'setEmptyVendorPartsList',
      'setOnEditVendorPart',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: this.gridId, settings: { columns: newColumns }});
    }, 500),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: this.gridId, settings: { columns: newColumns }});
    },
    onDelete: async function(item) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete this offer?'});
      if (deleteConfirmed) {
        await this.deleteOffer(item.id);
        this.deleteVendorPartFromList(item.id);
      }
    },
    onEdit: function(item) {
      this.setOnEditVendorPart(item);
    },
  },
  async mounted() {
    if (this.$route.params.companyId) {
      this.getOffersForCompanyId(this.$route.params.companyId);
    } else {
      this.setEmptyVendorPartsList([]);
    }
  }
};
</script>
